import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=605ed6ab&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=605ed6ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ed6ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605ed6ab')) {
      api.createRecord('605ed6ab', component.options)
    } else {
      api.reload('605ed6ab', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=605ed6ab&scoped=true&", function () {
      api.rerender('605ed6ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23hFhlu25PbqV/JS/comp/PopupDialog.vue"
export default component.exports